import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom';
import {connect} from 'react-redux';
import {loginFetchData} from "./login/LoginAction";
import {ConnectedRouter} from 'react-router-redux';
import {history} from './store/configureStore';
import OverviewScreen from "./overview/OverviewScreen";
import LevelScreen from "./level/LevelScreen";
import WorkoutScreen from "./workout/WorkoutScreen";
import FriendsScreen from "./friends/FriendsScreen";
import SurveyScreen from "./survey/SurveyScreen";
import DisabledScreen from "./disabled/DisabledScreen";
import RatingScreen from "./rating/RatingScreen";
import SuccessScreen from "./success/SuccessScreen";
import InviteScreen from "./invite/InviteScreen";
import PayoutScreen from "./payout/PayoutScreen";
import PayoutSuccessScreen from "./success/PayoutSuccessScreen";
import PauseScreen from "./pause/PauseScreen";
import InfoScreen from "./info/InfoScreen";
import WorkoutPreview from './workoutPreview/workoutPreview';
import MilestoneScreen from './milestone/MilestoneScreen';
import UpgradeScreen from "./upgrade/UpgradeScreen";
import LoginScreen from "./login/LoginScreen";
import { loadReCaptcha } from 'react-recaptcha-v3'
import WalletScreen from "./wallet/WalletScreen";
import FeedbackScreen from "./feedback/FeedbackScreen";
import ReorderScreen from "./reorder/ReorderScreen";

class MainScreen extends Component {

    componentDidMount() {
        loadReCaptcha("6Lc-2_gUAAAAAL9yUANfRxC2hRbPFI0jTvlvVQPB");
    }

    render() {
        return (
            <ConnectedRouter history={history}>
                <div style={{width: '100%'}}>
                    <Switch>
                        <Route exact path="/" component={OverviewScreen}/>
                        <Route path="/workout" component={WorkoutScreen}/>
                        <Route path="/workoutPreview" component={WorkoutPreview}/>
                        <Route path="/level" component={LevelScreen}/>
                        <Route path="/friends" component={FriendsScreen}/>
                        <Route path="/invite" component={InviteScreen}/>
                        <Route path="/rating/:day" exact component={RatingScreen}/>
                        <Route path="/success" component={SuccessScreen}/>
                        <Route path="/payoutSuccess" component={PayoutSuccessScreen}/>
                        {/*<Route path="/connect" component={ConnectScreen}/>*/}
                        <Route path="/survey" component={SurveyScreen}/>
                        <Route path="/disabled" component={DisabledScreen}/>
                        <Route path="/payout" component={PayoutScreen}/>
                        <Route path="/pause" component={PauseScreen}/>
                        <Route path="/info" component={InfoScreen}/>
                        <Route path="/milestone" component={MilestoneScreen} />
                        <Route path="/update" component={UpgradeScreen} />
                        <Route path="/wallet" component={WalletScreen} />
                        <Route path="/feedback" component={FeedbackScreen} />
                        <Route path="/reorder" component={ReorderScreen} />
                        <Route component={OverviewScreen}/>
                    </Switch>
                </div>
            </ConnectedRouter>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.auth.isLoggedIn,
        //loadingLoginFailed: state.loadingLoginFailed,
        //isLoading: state.loginIsLoading
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchData: (email, password) => dispatch(loginFetchData(email, password))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainScreen);




// WEBPACK FOOTER //
// ./src/MainScreen.js